import { apiClient } from './apiClient';
import { billingService } from './billingService';

export type PlanType = 'basic' | 'pro' | 'growth';

export interface Subscription {
  id: string;
  plan: PlanType | string;
  plan_code?: string;
  tier?: PlanType;
  includes_portalr?: boolean;
  status: 'trial' | 'active' | 'cancelled' | 'past_due' | 'expired' | 'unpaid';
  price: number | string;
  billing_period: 'monthly' | 'yearly';
  trial_ends_at: string | null;
  current_period_start: string | null;
  current_period_end: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface UpgradeResponse {
  message: string;
  subscription?: Subscription;
}

export interface CheckoutRedirectResponse {
  checkout_url: string;
  session_id: string;
  message: string;
}

class SubscriptionService {
  async getSubscription(): Promise<Subscription> {
    const response = await apiClient.get('/subscription/');
    return response;
  }

  /** Upgrade by plan_code (e.g. GS_GROWTH_YEARLY) - uses billing API and Stripe.
   * Returns either subscription data or checkout_url for redirect to Stripe Checkout. */
  async upgradeSubscription(planCode: string): Promise<UpgradeResponse | CheckoutRedirectResponse> {
    return billingService.upgrade(planCode);
  }
}

export const subscriptionService = new SubscriptionService();


